import { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
import { 
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function createUserProfile(user, defaultProfile = {}) {
    try {
      const token = await user.getIdToken();
      const response = await fetch('http://localhost:5000/api/userProfile', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          fullName: defaultProfile.fullName || '',
          address: defaultProfile.address || '',
          registrationType: defaultProfile.registrationType || 'customer',
          balance: 0
        })
      });

      if (!response.ok) {
        throw new Error('Nepodařilo se vytvořit profil');
      }

      return await response.json();
    } catch (error) {
      console.error('Chyba při vytváření profilu:', error);
      throw error;
    }
  }

  async function signup(email, password, profileData = {}) {
    try {
      // 1. Nejprve vytvoříme Firebase účet
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      
      // 2. Po úspěšné registraci vytvoříme profil
      await createUserProfile(userCredential.user, profileData);
      
      return userCredential.user;
    } catch (error) {
      console.error('Chyba při registraci:', error);
      throw error;
    }
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    signup,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 